package kz.dentalcrm.app.data.network.request_model

import kotlinx.serialization.Serializable

@Serializable
data class PositionRequest(
    val name: String,
    val description: String? = null
)
